<script setup lang="ts">
import EmbedVideo from '@/components/EmbedVideo.vue'

const { send } = useEvent()
const { user } = useLocalStorage()
const { updateKeys, getKey } = useGlobalConfig()
const { t } = useI18n()
const isClicked = ref(false)
const isLoaded = ref(false)

const getUserConfig = async () => {
  isClicked.value = await getKey('users', 'hasSubscriptionRegistration')
  isLoaded.value = true
}

const handleClick = async () => {
  isClicked.value = true

  await updateKeys('users', {
    hasSubscriptionRegistration: true
  })
  send('segment', 'subscription:register:clicked', {
    email: user.value.email
  })
}

const arrowImg = `${import.meta.env.VITE_AWS_STORAGE_URL}/illustrations/arrow.svg`

getUserConfig()
</script>
<template>
  <div class="relative mt-8 px-6 pb-6 text-center sm:px-12 sm:pb-12">
    <div class="mx-auto max-w-3xl">
      <h2 class="mx-auto mb-8 w-fit -rotate-6">
        <BaseChip color="violet" :text="t('pages.subscription.register.label')" />
      </h2>
      <div class="mb-5 text-foreground">
        <h3 class="mb-4 text-2xl font-bold">{{ t('pages.subscription.register.title') }}</h3>
        <p class="md:leading-8">
          {{ t('pages.subscription.register.description') }}
        </p>
      </div>
      <template v-if="isLoaded">
        <div v-if="isClicked" class="mb-8 w-full rounded-lg bg-muted p-5">
          <h4 class="mb-1 text-sm text-foreground">
            {{ t('pages.subscription.register.received.title') }}
          </h4>
          <p class="mx-auto max-w-lg text-xs leading-6 text-muted-foreground">
            {{ t('pages.subscription.register.received.description', { email: user.email }) }}
          </p>
        </div>
        <div v-else class="mb-11 flex">
          <div class="-mt-12 mr-3 hidden flex-col items-end justify-center md:flex">
            <BaseChip color="gray" :text="t('pages.subscription.register.waitingList.soon')" />
          </div>
          <img :src="arrowImg" alt="" class="mr-6 mt-5 hidden w-14 md:block" />
          <div class="mx-auto block md:pt-10">
            <Button variant="default-primary" class="flex items-center" @click="handleClick">
              {{ t('pages.subscription.register.waitingList.alert') }}
              <BaseIcon name="HeroBellIconSolid" class="ml-2 h-4 w-4" />
            </Button>
          </div>
          <img :src="arrowImg" alt="" class="ml-6 mt-8 hidden w-14 rotate-180 md:block" />
          <div class="ml-3 mt-20 hidden flex-col items-start justify-center md:flex">
            <BaseChip color="gray">
              <template #label>
                <span class="text-sm font-medium text-black">
                  {{ t('pages.subscription.register.waitingList.be')
                  }}<sup class="text-[9px] text-black">{{ t('pages.subscription.register.waitingList.first') }}</sup>
                  👑
                </span>
              </template>
            </BaseChip>
          </div>
        </div>
      </template>
    </div>
    <template v-if="isLoaded">
      <div class="mx-auto max-w-3xl">
        <EmbedVideo
          link="https://www.youtube.com/embed/YXgdVU9KOZ8?loop=1&showinfo=0&rel=0&modestbranding=1&iv_load_policy=3"
        />
      </div>
    </template>
  </div>
</template>
